import type { FieldValues } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { FormField, type FormFieldBaseProps } from './FormField';
import { cn } from '@/lib/utils';

export interface TextFieldProps<T extends FieldValues> extends FormFieldBaseProps<T> {
  type?: 'text' | 'email' | 'password' | 'tel' | 'url';
  placeholder?: string;
  autoComplete?: string;
  disabled?: boolean;
}

export function TextField<T extends FieldValues>(props: TextFieldProps<T>): JSX.Element {
  const { type = 'text', placeholder, autoComplete, disabled, ...rest } = props;
  return (
    <FormField {...rest}>
      {({ value, onChange, onBlur, id, invalid }) => (
        <Input
          id={id}
          type={type}
          value={(value as string) ?? ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          className={cn(invalid && 'border-destructive focus-visible:ring-destructive')}
        />
      )}
    </FormField>
  );
}
